import React from 'react';
import { TrendingUp, TrendingDown, DollarSign, Award, FileText, CheckCircle } from 'lucide-react';

const stats = [
  {
    name: 'Total Contract Value',
    value: '$12.4M',
    change: '+12.5%',
    changeType: 'increase',
    icon: DollarSign,
  },
  {
    name: 'Win Rate',
    value: '68%',
    change: '+4.2%',
    changeType: 'increase',
    icon: Award,
  },
  {
    name: 'Active Proposals',
    value: '24',
    change: '-2',
    changeType: 'decrease',
    icon: FileText,
  },
  {
    name: 'Compliance Score',
    value: '94%',
    change: '+2.1%',
    changeType: 'increase',
    icon: CheckCircle,
  },
];

export function AnalyticsSummary() {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.name}
            className="relative overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:px-6"
          >
            <dt>
              <div className="absolute rounded-md bg-indigo-500 p-3">
                <Icon className="h-6 w-6 text-white" />
              </div>
              <p className="ml-16 truncate text-sm font-medium text-gray-500">{stat.name}</p>
            </dt>
            <dd className="ml-16 flex items-baseline">
              <p className="text-2xl font-semibold text-gray-900">{stat.value}</p>
              <p
                className={`ml-2 flex items-baseline text-sm font-semibold ${
                  stat.changeType === 'increase' ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {stat.changeType === 'increase' ? (
                  <TrendingUp className="h-4 w-4" />
                ) : (
                  <TrendingDown className="h-4 w-4" />
                )}
                <span className="ml-1">{stat.change}</span>
              </p>
            </dd>
          </div>
        );
      })}
    </div>
  );
}